var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"text-center"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('highcharts',{staticClass:"mt-4 w-100",attrs:{"options":_vm.downtimeByMachineOptions}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }